import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const HandMiniIcon = ({
  width = 26,
  color = 'black',
  marginRight,
  marginLeft,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 23">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M2.296 13.756l2.548 6.65c.14.367-.253.843-.879 1.064-.626.221-1.247.103-1.389-.265L.028 14.556c-.13-.34.2-.775.749-1.013l.13-.05c.626-.223 1.248-.104 1.389.263zm8.102-2.993c.8.294 1.53.745 2.388.745h1.472c.952 0 1.867.838 2.397 1.603.334.48.114.683-.087.886l-3.03-.133-2.051-.059c-.525 0-.964.422-1.401 1.36l-.021.047c.017-.029.22-.297 1.796-.359l1.66.033 1.67.075c1.036-.014 4.205-.009 4.578-.2l3.272-1.932c1.643-.834 2.034-.683 2.507-.047.22.297.16.712-.131.946l-5.54 4.377c-.29.27-.723.735-1.122.79h-.008c-.158.034-.321.054-.488.054l-4.616.677-.301.044c-.745.11-1.497.165-2.251.165l-5.373-.209-2.325-6.086s3.678-4 7.005-2.777zM14.832 1.5c1.89 0 3.422 1.48 3.422 3.305 0 1.825-1.532 3.305-3.422 3.305-1.89 0-3.422-1.48-3.422-3.305 0-1.825 1.533-3.305 3.422-3.305z"
      />
    </svg>
  </DefaultIconWrapper>
);
